import React, { Fragment } from 'react'
import styled, { css } from 'react-emotion'
import { color, spacer, shadow } from 'stylist'

const dynamicWidth = props => css`
  width: ${props.width};
`

const ProgressWrapper = styled.div`
  width: 100%;
  background-color: ${color('ink')};
  position: relative;
  height: ${spacer(4)};
  border-radius: ${spacer(1)};
`

const Bar = styled.div`
  background-color: ${color('brandGreen')};
  height: 100%;
  position: absolute;
  box-shadow: ${shadow('distant')};
  border-radius: ${spacer(1)};
  ${dynamicWidth};
`

const ProgressReport = styled.h5`
  margin-top: ${spacer(3)};
`

const progressPercentage = progress => progress + '%'

export const ProgressBar = ({ progress }) => (
  <Fragment>
    <ProgressWrapper>
      <Bar width={progressPercentage(progress)} />
    </ProgressWrapper>
    <ProgressReport>
      Upload Progress: {progressPercentage(progress)}
    </ProgressReport>
  </Fragment>
)

export default ProgressBar



// WEBPACK FOOTER //
// ./src/components/ProgressBar.js